// The CDN serves the institutional shell on the first journal visit.
// A versioned worker sends journal navigation and assets to the same gateway.
const WORKER_URL = '/sw.js?journal=20261027';

async function prepareJournalNavigation() {
  if (!('serviceWorker' in navigator)) return;
  const expected = new URL(WORKER_URL, window.location.origin).href;
  const ready = () => navigator.serviceWorker.controller?.scriptURL === expected;
  if (ready()) return;
  let registrationTimer;
  try {
    await Promise.race([
      navigator.serviceWorker.register(WORKER_URL, { scope: '/', updateViaCache: 'none' }),
      new Promise((_, reject) => {
        registrationTimer = setTimeout(() => reject(new Error('journal worker registration timeout')), 12000);
      }),
    ]);
  } finally {
    clearTimeout(registrationTimer);
  }
  // Subscribe before checking: activation/control may already have happened.
  await new Promise((resolve, reject) => {
    let timer;
    const finish = (error) => {
      clearTimeout(timer);
      navigator.serviceWorker.removeEventListener('controllerchange', check);
      if (error) reject(error); else resolve();
    };
    const check = () => { if (ready()) finish(); };
    timer = setTimeout(() => finish(new Error('journal worker activation timeout')), 12000);
    navigator.serviceWorker.addEventListener('controllerchange', check);
    check();
  });
}

export async function loadJournalDocument() {
  const root = document.getElementById('root');
  const initial = root.querySelector('[data-journal-static]');
  const notice = document.createElement('p');
  notice.className = 'journal-loading-status';
  notice.setAttribute('role', 'status');
  notice.textContent = 'Cargando lector interactivo…';
  if (initial) {
    initial.prepend(notice);
  } else {
    document.title = 'MedETechni Journal of Translational Research';
    root.textContent = 'Cargando MedETechni Journal…';
  }
  const controller = new AbortController();
  let timer;
  try {
    await prepareJournalNavigation();
    timer = setTimeout(() => controller.abort(), 20000);
    const response = await fetch('/api/journal-render' + window.location.pathname.slice('/journal'.length) + window.location.search, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: controller.signal,
    });
    if (!response.ok || !(response.headers.get('content-type') || '').includes('text/html')) throw new Error('journal unavailable');
    const html = await response.text();
    if (!/^<!doctype html/i.test(html.trim())) throw new Error('invalid document');
    document.open();
    document.write(html);
    document.close();
  } catch (error) {
    console.error('[Journal] Document load failed:', error);
    if (initial) {
      notice.textContent = 'El texto completo sigue disponible. No se pudo cargar el lector interactivo.';
    } else {
      root.textContent = 'No pudimos cargar la revista. Conserva tu texto y vuelve a intentarlo.';
    }
    const retry = document.createElement('button');
    retry.textContent = 'Volver a intentar';
    retry.onclick = () => window.location.reload();
    (initial || root).appendChild(retry);
  } finally {
    clearTimeout(timer);
  }
}
